var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorLung100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 80,
    viewBox: "0 0 118 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 78.25,
    x2: 118,
    y2: 78.25,
    stroke: "black",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorLung100);
export default __webpack_public_path__ + "static/media/conductor_lung_100.3658e2d264f06d5aaa390191c6665271.svg";
export { ForwardRef as ReactComponent };